import { Link } from "wouter";
import { MapPin, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";
import { useI18n } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useI18n();

  return (
    <div className="min-h-screen flex flex-col bg-background">
            
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
            <MapPin className="h-10 w-10 text-primary" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <h2 className="text-xl font-semibold mb-2">{t("notFound.title")}</h2>
          <p className="text-muted-foreground mb-8 max-w-md">
            {t("notFound.desc")}
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link href="/">
              <Button data-testid="button-go-home">
                <Home className="h-4 w-4 mr-2" />
                {t("notFound.goHome")}
              </Button>
            </Link>
            <Link href="/routes">
              <Button variant="outline" data-testid="button-discover-routes">
                <MapPin className="h-4 w-4 mr-2" />
                {t("routes.discover")}
              </Button>
            </Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
